import { render, staticRenderFns } from "./zlxz.vue?vue&type=template&id=d0803a52&scoped=true&"
import script from "./zlxz.vue?vue&type=script&lang=js&"
export * from "./zlxz.vue?vue&type=script&lang=js&"
import style0 from "./zlxz.vue?vue&type=style&index=0&id=d0803a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0803a52",
  null
  
)

export default component.exports